import {InjectionToken} from '@angular/core';
import {AuthenticationServiceBase} from '~shared/types/authentication.types';

export const AUTHENTICATION_TOKEN = new InjectionToken<AuthenticationServiceBase>('AuthenticationService');
